<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M10.9934,6.99588C10.9934,6.99588,4.99696,6.99588,4.99696,6.99588C4.44729,6.99588,3.99756,7.44562,3.99756,7.99529C3.99756,8.54497,4.44729,8.9947,4.99696,8.9947C4.99696,8.9947,10.9934,8.9947,10.9934,8.9947C11.5431,8.9947,11.9928,8.54497,11.9928,7.99529C11.9928,7.44562,11.5431,6.99588,10.9934,6.99588C10.9934,6.99588,10.9934,6.99588,10.9934,6.99588ZM7.99523,0C3.57787,0,0,3.57789,0,7.99529C0,12.4127,3.57787,15.9906,7.99523,15.9906C12.4126,15.9906,15.9905,12.4127,15.9905,7.99529C15.9905,3.57789,12.4126,0,7.99523,0C7.99523,0,7.99523,0,7.99523,0ZM7.99572,13.9918C4.68769,13.9918,1.9993,11.3033,1.9993,7.9953C1.9993,4.68724,4.68769,1.99883,7.99572,1.99883C11.3037,1.99883,13.9921,4.68724,13.9921,7.9953C13.9921,11.3033,11.3137,13.9918,7.99572,13.9918C7.99572,13.9918,7.99572,13.9918,7.99572,13.9918Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Remove',
} as DefineComponent
</script>
